/**
 * 2021-3-29 建模仿真导入导出excel数据模板
 * 带有表格的数据
 */

const templateData = {
    // 燃气轮机
    GasTurbine: [
        {
            key: 'manufacturer',
            name: '生产厂商',
        },
        {
            key: 'equipType',
            name: '设备型号',
        },
        {
            key: 'LocalPressureDropCoe',
            name: '局部压降系数(kPa/(m³·s⁻¹)²)',
        },
        {
            key: 'PowerFactor',
            name: '功率因数',
        },
        {
            key: 'GeneratingPower',
            name: '发电功率[kW]',
        },
        {
            key: 'GeneratingEfficiency',
            name: '发电效率[%]',
        },
        {
            key: 'HeatEfficiency',
            name: '制热效率[%]',
        },
        {
            key: 'MiniOutletTemp',
            name: '最小供水温度 (℃)',
        },
        {
            key: 'MaxOutletTemp',
            name: '最大供水温度 (℃)',
        },
        {
            key: 'PurchaseCost',
            name: '采购成本(万元/台)',
        },
        {
            key: 'FixedOMCost',
            name: '固定运维成本(万元/年)',
        },
        {
            key: 'VariableOMCost',
            name: '可变运维成本(元/kWh)',
        },
    ],
    // 热泵
    HeatPump: [
        {
            key: 'manufacturer',
            name: '生产厂商',
        },
        {
            key: 'equipType',
            name: '设备型号',
        },
        {
            key: 'LocalPressureDropCoe',
            name: '局部压降系数(kPa/(m³·s⁻¹)²)',
        },
        {
            key: 'PowerFactor',
            name: '功率因数',
        },
        {
            key: 'COP',
            name: 'COP',
        },
        {
            key: 'EnergySupply',
            name: '制冷制热功率[kW](制冷为负，制热为正)',
        },
        {
            key: 'MiniHeatOutletTemp',
            name: '制热最小供水温度 (℃)',
        },
        {
            key: 'MaxHeatOutletTemp',
            name: '制热最大供水温度 (℃)',
        },
        {
            key: 'MiniCoolOutletTemp',
            name: '制冷最小供水温度 (℃)',
        },
        {
            key: 'MaxCoolOutletTemp',
            name: '制冷最大供水温度 (℃)',
        },
        {
            key: 'PurchaseCost',
            name: '采购成本(万元/台)',
        },
        {
            key: 'FixedOMCost',
            name: '固定运维成本(万元/年)',
        },
        {
            key: 'VariableOMCost',
            name: '可变运维成本(元/kWh)',
        },
    ],
    // 燃气锅炉
    GasBoiler: [
        {
            key: 'manufacturer',
            name: '生产厂商',
        },
        {
            key: 'equipType',
            name: '设备型号',
        },
        {
            key: 'LocalPressureDropCoe',
            name: '局部压降系数(kPa/(m³·s⁻¹)²)',
        },
        {
            key: 'HeatEfficiency',
            name: '制热效率[%]',
        },
        {
            key: 'HeatPower',
            name: '供热功率[kW]',
        },
        {
            key: 'MiniOutletTemp',
            name: '最小供水温度 (℃)',
        },
        {
            key: 'MaxOutletTemp',
            name: '最大供水温度 (℃)',
        },
        {
            key: 'PurchaseCost',
            name: '采购成本(万元/台)',
        },
        {
            key: 'FixedOMCost',
            name: '固定运维成本(万元/年)',
        },
        {
            key: 'VariableOMCost',
            name: '可变运维成本(元/kWh)',
        },
    ],
    // 电压缩制冷机
    CompRefrg: [
        {
            key: 'manufacturer',
            name: '生产厂商',
        },
        {
            key: 'equipType',
            name: '设备型号',
        },
        {
            key: 'LocalPressureDropCoe',
            name: '局部压降系数(kPa/(m³·s⁻¹)²)',
        },
        {
            key: 'PowerFactor',
            name: '功率因数',
        },
        {
            key: 'COP',
            name: 'COP',
        },
        {
            key: 'CoolSupply',
            name: '制冷功率[kW]',
        },
        {
            key: 'MiniOutletTemp',
            name: '最小供水温度 (℃)',
        },
        {
            key: 'MaxOutletTemp',
            name: '最大供水温度 (℃)',
        },
        {
            key: 'PurchaseCost',
            name: '采购成本(万元/台)',
        },
        {
            key: 'FixedOMCost',
            name: '固定运维成本(万元/年)',
        },
        {
            key: 'VariableOMCost',
            name: '可变运维成本(元/kWh)',
        },
    ],
    // 收缩式制冷机
    AbsorptionChiller: [
        {
            key: 'manufacturer',
            name: '生产厂商',
        },
        {
            key: 'equipType',
            name: '设备型号',
        },
        {
            key: 'PrimaryLocalPressureDropCoe',
            name: '热水侧局部压降系数(kPa/(m³·s⁻¹)²)',
        },
        {
            key: 'SecondaryLocalPressureDropCoe',
            name: '冷水侧局部压降系数(kPa/(m³·s⁻¹)²)',
        },
        {
            key: 'PowerFactor',
            name: '功率因数',
        },
        {
            key: 'CoolHeatRatio',
            name: '冷热比',
        },
        {
            key: 'CoolSupply',
            name: '制冷功率[kW]',
        },
        {
            key: 'PowerConsume',
            name: '电功率[kW]',
        },
        {
            key: 'PrimaryMaxOutletTemp',
            name: '热水侧最大出口温度(℃)',
        },
        {
            key: 'PrimaryMiniOutletTemp',
            name: '热水侧最小出口温度(℃)',
        },
        {
            key: 'SecondaryMaxOutletTemp',
            name: '冷水侧最大出口温度(℃)',
        },
        {
            key: 'SecondaryMiniOutletTemp',
            name: '冷水侧最小出口温度 (℃)',
        },
        {
            key: 'PurchaseCost',
            name: '采购成本(万元/台)',
        },
        {
            key: 'FixedOMCost',
            name: '固定运维成本(万元/年)',
        },
        {
            key: 'VariableOMCost',
            name: '可变运维成本(元/kWh)',
        },
    ],
    // 离心泵
    CentrifugalPump: [
        {
            key: 'manufacturer',
            name: '生产厂商',
        },
        {
            key: 'equipType',
            name: '设备型号',
        },
        {
            key: 'RatedPumpSpeed',
            name: '额定转速 (rpm)',
        },
        {
            key: 'MaxPumpSpeed',
            name: '最大工作转速',
        },
        {
            key: 'MinPumpSpeed',
            name: '最小工作转速',
        },
        {
            key: 'PowerFactor',
            name: '功率因数',
        },
        {
            key: 'MassFlowrate',
            name: '流量（m³/h）',
        },
        {
            key: 'Lift',
            name: '扬程（m）',
        },
        {
            key: 'Effiency',
            name: '效率（%）',
        },
        {
            key: 'PurchaseCost',
            name: '采购成本(万元/台)',
        },
        {
            key: 'FixedOMCost',
            name: '固定运维成本(万元/年)',
        },
    ],
};

export default templateData;
